import { QuoteActions, QuoteActionTypes } from "../actions/quote.action";

export interface QuoteState {
  quotes: any;
  quotesLoading: boolean;
  quotesError: boolean;

  quote: any;
  quoteLoading: boolean;
  quoteError: boolean;

  createRentalQuoteSuccess: boolean;
  createRentalQuoteLoading: boolean;
  createRentalQuoteError: boolean;
  createdRentalQuote: any;

  createPurchaseQuoteSuccess: boolean;
  createPurchaseQuoteLoading: boolean;
  createPurchaseQuoteError: boolean;
  createdPurchaseQuote: any;
  createdPurchaseLineItems: any

  createPurchaseLineItemSuccess: boolean,
  createPurchaseLineItemLoading: boolean,
  createPurchaseLineItemError: boolean,

  updateQuoteSuccess: boolean;
  updateQuoteLoading: boolean;
  updateQuoteError: boolean;
  updatedQuote: any;

  downloadQuoteLoading: boolean;
  downloadQuoteError: boolean;

  downloadPurchaseQuoteLoading: boolean;
  downloadPurchaseQuoteError: boolean;

  report: any;
  reportLoading: boolean;
  reportError: boolean;
}

export const initialState: QuoteState = {
  quotes: [],
  quotesLoading: false,
  quotesError: false,

  quote: null,
  quoteLoading: false,
  quoteError: false,

  createRentalQuoteSuccess: false,
  createRentalQuoteLoading: false,
  createRentalQuoteError: false,
  createdRentalQuote: null,

  createPurchaseQuoteSuccess: false,
  createPurchaseQuoteLoading: false,
  createPurchaseQuoteError: false,
  createdPurchaseQuote: null,
  createdPurchaseLineItems: null,

  createPurchaseLineItemSuccess: false,
  createPurchaseLineItemLoading: false,
  createPurchaseLineItemError: false,

  updateQuoteSuccess: false,
  updateQuoteLoading: false,
  updateQuoteError: false,
  updatedQuote: null,

  downloadQuoteLoading: false,
  downloadQuoteError: false,

  downloadPurchaseQuoteLoading: false,
  downloadPurchaseQuoteError: false,

  report: null,
  reportLoading: false,
  reportError: false,
};

export function reducer(
  state = initialState,
  action: QuoteActions
): QuoteState {
  switch (action.type) {
    case QuoteActionTypes.GET_QUOTE_LIST: {
      return {
        ...state,
        quotesLoading: true,
        quotesError: false,
      };
    }

    case QuoteActionTypes.GET_QUOTE_LIST_SUCCESS: {
      return {
        ...state,
        quotes: action.payload,
        quotesLoading: false,
        quotesError: false,
      };
    }

    case QuoteActionTypes.GET_QUOTE_LIST_FAILURE: {
      return {
        ...state,
        quotesLoading: false,
        quotesError: true,
      };
    }

    case QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST: {
      return {
        ...state,
        quotesLoading: true,
        quotesError: false,
      };
    }

    case QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST_SUCCESS: {
      return {
        ...state,
        quotes: action.payload,
        quotesLoading: false,
        quotesError: false,
      };
    }

    case QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST_FAILURE: {
      return {
        ...state,
        quotesLoading: false,
        quotesError: true,
      };
    }

    case QuoteActionTypes.GET_SALES_QUOTE_LIST: {
      return {
        ...state,
        quotesLoading: true,
        quotesError: false,
      };
    }

    case QuoteActionTypes.GET_SALES_QUOTE_LIST_SUCCESS: {
      return {
        ...state,
        quotes: action.payload,
        quotesLoading: false,
        quotesError: false,
      };
    }

    case QuoteActionTypes.GET_SALES_QUOTE_LIST_FAILURE: {
      return {
        ...state,
        quotesLoading: false,
        quotesError: true,
      };
    }

    case QuoteActionTypes.CLEAR_QUOTE_LIST: {
      return {
        ...state,
        quotes: [],
        quotesLoading: false,
        quotesError: false,
        quote: null,
        quoteLoading: false,
        quoteError: false,
      };
    }

    case QuoteActionTypes.GET_QUOTE: {
      return {
        ...state,
        quoteLoading: true,
        quoteError: false,
      };
    }

    case QuoteActionTypes.GET_QUOTE_SUCCESS: {
      return {
        ...state,
        quote: action.payload,
        quoteLoading: false,
        quoteError: false,
      };
    }

    case QuoteActionTypes.GET_QUOTE_FAILURE: {
      return {
        ...state,
        quoteLoading: false,
        quoteError: true,
      };
    }

    case QuoteActionTypes.CREATE_RENTAL_QUOTE: {
      return {
        ...state,
        createRentalQuoteLoading: true,
        createRentalQuoteError: false,
      };
    }

    case QuoteActionTypes.CREATE_RENTAL_QUOTE_SUCCESS: {
      return {
        ...state,
        // quotes: [...state.quotes, action.payload],
        createdRentalQuote: action.payload,
        createRentalQuoteSuccess: true,
        createRentalQuoteLoading: false,
        createRentalQuoteError: false,
      };
    }

    case QuoteActionTypes.CREATE_RENTAL_QUOTE_FAILURE: {
      return {
        ...state,
        createRentalQuoteLoading: false,
        createRentalQuoteError: true,
      };
    }

    case QuoteActionTypes.CREATE_PURCHASE_QUOTE: {
      return {
        ...state,
        createPurchaseQuoteLoading: true,
        createPurchaseQuoteError: false,
      };
    }

    case QuoteActionTypes.CREATE_PURCHASE_QUOTE_SUCCESS: {
      return {
        ...state,
        // quotes: [...state.quotes, action.payload],
        createdPurchaseQuote: action.payload,
        createPurchaseQuoteSuccess: true,
        createPurchaseQuoteLoading: false,
        createPurchaseQuoteError: false,
      };
    }

    case QuoteActionTypes.CREATE_PURCHASE_QUOTE_FAILURE: {
      return {
        ...state,
        createPurchaseQuoteLoading: false,
        createPurchaseQuoteError: true,
      };
    }

    case QuoteActionTypes.UPDATE_QUOTE: {
      return {
        ...state,
        updateQuoteLoading: true,
        updateQuoteError: false,
      };
    }

    case QuoteActionTypes.UPDATE_QUOTE_SUCCESS: {
      return {
        ...state,
        updateQuoteSuccess: true,
        updateQuoteLoading: false,
        updateQuoteError: false,
      };
    }

    case QuoteActionTypes.UPDATE_QUOTE_FAILURE: {
      return {
        ...state,
        updateQuoteLoading: false,
        updateQuoteError: true,
      };
    }

    case QuoteActionTypes.DOWNLOAD_QUOTE: {
      return {
        ...state,
        downloadQuoteLoading: true,
        downloadQuoteError: false,
      };
    }

    case QuoteActionTypes.DOWNLOAD_QUOTE_SUCCESS: {
      return {
        ...state,
        downloadQuoteLoading: false,
        downloadQuoteError: false,
      };
    }

    case QuoteActionTypes.DOWNLOAD_QUOTE_FAILURE: {
      return {
        ...state,
        downloadQuoteLoading: false,
        downloadQuoteError: true,
      };
    }

    case QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE: {
      return {
        ...state,
        downloadPurchaseQuoteLoading: true,
        downloadPurchaseQuoteError: false,
      };
    }

    case QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE_SUCCESS: {
      return {
        ...state,
        downloadPurchaseQuoteLoading: false,
        downloadPurchaseQuoteError: false,
      };
    }

    case QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE_FAILURE: {
      return {
        ...state,
        downloadPurchaseQuoteLoading: false,
        downloadPurchaseQuoteError: true,
      };
    }

    case QuoteActionTypes.EMAIL_REPORT: {
      return {
        ...state,
        report: null,
        reportLoading: true,
        reportError: false,
      };
    }

    case QuoteActionTypes.EMAIL_REPORT_SUCCESS: {
      return {
        ...state,
        report: action.payload,
        reportLoading: false,
        reportError: false,
      };
    }

    case QuoteActionTypes.EMAIL_REPORT_FAILURE: {
      return {
        ...state,
        report: null,
        reportLoading: false,
        reportError: true,
      };
    }

    default:
      return state;
  }
}
